import { Card, CardContent, Typography } from '@mui/material';

const SensorCard = ({ sensor, formatDate }) => {
  return (
    <Card
      sx={{
        width: { xs: 150, sm: 180 },
        backgroundColor: sensor.Fault ? '#ffebee' : '#e8f5e9',
        borderLeft: '6px solid',
        borderColor: sensor.Fault ? 'error.main' : 'success.main',
      }}
    >
      <CardContent>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          gutterBottom
        >
          {sensor.DeviceName}
        </Typography>
        <Typography variant= "h6" align="center" sx={{fontSize: { xs: '1rem', sm: '1.25rem'}}} gutterBottom>
          {sensor.SensorName}
        </Typography>
        {sensor.Fault ? (
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            color="error.main"
          >
            Falla
          </Typography>
        ) : (
          <Typography variant="h5" align="center" fontWeight="bold">
            {parseFloat(sensor.SensorValue).toFixed(1)}°C
          </Typography>
        )}
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          mt={1}
        >
          {formatDate(sensor.RecordTime)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SensorCard;
